import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { IoLogoWhatsapp } from "react-icons/io5";
import { useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import Notification, {showToast} from "../../components/common/notification/Notification";
import MobileVerification from "../../components/verification/MobileVerification";
import { loginSuccess } from "../../features/auth/authSlice";
import "./AuthForm.css";

const AuthForm = ({
  type,
  title,
  subtitle,
  image,
  redirectOnSuccess,
  footerText,
  footerLink,
  footerPath,
  userType,
}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verifiedResponse, setVerifiedResponse] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Already logged in check
  useEffect(() => {
    const savedAuth = secureLocalStorage.getItem("auth");
    if (savedAuth && savedAuth.token) {
      dispatch(loginSuccess(savedAuth));
      navigate("/dashboard/myspace", { replace: true });
    }
  }, [dispatch, navigate]);

  // After OTP verification
  useEffect(() => {
    if (verifiedResponse?.statusType === "SUCCESS") {
      dispatch(loginSuccess(verifiedResponse));
      secureLocalStorage.setItem("auth", verifiedResponse);
      secureLocalStorage.setItem("token", verifiedResponse.token);
      secureLocalStorage.setItem("refreshToken", verifiedResponse.refreshToken);
      navigate(redirectOnSuccess, { replace: true });
      window.location.reload();
    }
  }, [verifiedResponse, dispatch, navigate, redirectOnSuccess]);

  return (
    <Container 
      fluid 
      className="auth-container d-flex justify-content-center align-items-center"
    >
      <Notification />
      <Row className="auth-card shadow rounded-4 overflow-hidden">
        {/* Left Image */}
        <Col md={6} className="auth-image d-none d-md-flex justify-content-center align-items-center">
          <Image src={image} alt={`${type} illustration`} fluid />
        </Col>

        {/* Right Form */}
        <Col xs={10} md={6} className="auth-form p-4">
          <h2 className="text-center fw-bold mb-2">{title}</h2>
          <p className="text-center text-muted mb-3">{subtitle}</p>

          {/* Phone Input */}
          <Form>
            <Form.Group className="mb-2" controlId="formPhone">
              <div className="d-flex align-items-center border rounded-3 px-2 py-0 bg-light">
                <IoLogoWhatsapp className="me-2 fs-2" style={{ color: "#25D366" }} />
                <Form.Control
                  type="tel"
                  placeholder="Phone number"
                  value={phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 10) setPhoneNumber(value);
                  }}
                  required
                  inputMode="numeric"
                  maxLength={10}
                  className="border-0 shadow-none bg-transparent"
                />
              </div>
            </Form.Group>
          </Form>

          {/* OTP Verification */}
          {phoneNumber.length === 10 && (
            <MobileVerification
              mobileNumber={"91" + phoneNumber}
              action={type}
              userType={userType}
              onMobileVerified={setVerifiedResponse}
            />
          )}

          {/* Footer */}
          <div className="text-center mt-4">
            <p className="mb-0">
              <span className="text-muted px-1">{footerText}</span>
              <Link to={footerPath} className="fw-semibold text-primary text-decoration-none">
                {footerLink}
              </Link>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthForm;
